// import React, { useState } from "react";
// import { useForm } from "react-hook-form";
// import { Label } from "./ui/label";
// import {
//   Form,
//   FormControl,
//   FormField,
//   FormItem,
//   FormLabel,
//   FormMessage,
// } from "./ui/form";
// import { Input } from "./ui/input";
// import { Button } from "./ui/button";
// import { zodResolver } from "@hookform/resolvers/zod";

// import {
//   Command,
//   CommandEmpty,
//   CommandGroup,
//   CommandInput,
//   CommandItem,
//   CommandList,
// } from "./ui/command";
// import { z } from "zod";
// import { useMutation } from "react-query";
// import useAxiosPrivate from "../hooks/useAxiosPrivate";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useToast } from "./ui/use-toast";
// import { ClipLoader } from "react-spinners";
// import { cn } from "../lib/utils";
// import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
// import { Check, ChevronsUpDown } from "lucide-react";
// import { useSelector } from "react-redux";
// import { RadioGroup, RadioGroupItem } from "./ui/radio-group";

// function SgtinModal({ latitude, longitude }) {
//   const axiosPrivate = useAxiosPrivate();
//   const [togglecharset, setToggleCharset] = useState(true)
//   const navigate = useNavigate();
//   const location = useLocation();
// const { allClients } = useSelector((state) => state.clients);
//   const { toast } = useToast();
//   const [readpoint, setReadpoint] = useState([]);
//   const [prodName, setProdName] = useState();
//   const [loading, setLoading] = useState(false);
//   const [prods, setProds] = useState([]);
//   const formSchema = z.object({
//     clientKey: z.string({
//       message: "This field is required",
//     }),
//     mode: z.string({
//       message: "This field is required",
//     }),
//     length: z.string({
//       message: "This field is required",
//     }),
//     charSet: z.string({
//       message: "This field is required",
//     }),
//     gtin: z.string({
//       message: "This field is required",
//     }),
//     readpoint: z.string({
//       message: "This field is required",
//     }),
//     expiryDate: z.string({
//       message: "This field is required",
//     }),
//     mfgDate: z.string({
//       message: "This field is required",
//     }),
//     qty: z.string({
//       message: "This field is required",
//     }),
//     tag: z.string({
//       message: "This field is required",
//     }),
//     lotNumber: z.string({
//       message: "This field is required",
//     }),
//   });
//   const form = useForm({
//     resolver: zodResolver(formSchema),
//     defaultValues: {
//       clientKey: "",
//       gtin: "",
//       readpoint: "",
//       qty: "",
//       tag: "",
//       lotNumber: "",
//     },
//   });
//   function onSubmit(data) {
//     const payload = {
//       eventObjectParameter: {
//         eventTime: new Date().toISOString(),
//         recordTime: new Date().toISOString(),
//         latitude: latitude,
//         longitude: longitude,
//         readPoint: data.readpoint,
//         timeZone: "+01:00",
//         bizStep: "urn:epcglobal:cbv:bizstep:encoding",
//         disposition: "urn:epcglobal:cbv:disp:active",
//       },

//       gtin: data.gtin.substring(0, data.gtin.indexOf(",")),
//       clientKey: data.clientKey,
//       mode: data.mode,
//       charSet: data.charSet,
//       length: data.length,
//       qty: parseInt(data.qty),
//       lotNumber: data.lotNumber,
//       expiryDate: new Date(data.expiryDate),
//       mfgDate: new Date(data.mfgDate),
//       tag: data.tag,
//       prodId: data.gtin.substring(
//         data.gtin.indexOf(",") + 1,
//         data.gtin.lastIndexOf(",")
//       ),
//       prodName: data.gtin.substring(data.gtin.lastIndexOf(",") + 1),
//     };
//     if (data.charSet === "alpha-numeric" && data.mode === "seq") {
//       toast({
//         variant: "destructive",
//         title: "Error",
//         description: `Invalid selection`,

//       });

//     }
//     else {
//       setLoading(true);
//     mutate(payload);
//     }

//   }

//   const submitSGTIN = async (data) => {
//     return await axiosPrivate.post(`queues/sgtin`, data);
//   };

//   const { mutate } = useMutation((variables) => submitSGTIN(variables), {
//     onSuccess(data, variables, context) {
//       toast({
//         variant: "success",
//         title: "Success",
//         description: `${data.data.message}`,
//       });
//       setLoading(false);
//     },
//     onError(error) {
//       setLoading(false);
//       if (error.code === "ERR_NETWORK") {
//         navigate("/", { state: { from: location }, replace: true });
//       } else if (error.response.status === 401)
//         navigate("/", { state: { from: location }, replace: true });
//       else {
//         toast({
//           variant: "destructive",
//           title: "Error",
//           description: `${error?.response?.data?.message}`,
//         });
//       }
//     },
//   });

//   const getlocationbyKey = async (key) => {
//     const response = await axiosPrivate.get(`location/client/${key.clientKey}`);
//     return response;
//   };

//   const getProductsbyKey = async (key) => {
//     const response = await axiosPrivate.get(`client/products/${key.clientKey}`);
//     return response;
//   };

//   const handleChange = async (key) => {
//     try {
//       const readpointResponse = await getlocationbyKey({ clientKey: key });
//       setReadpoint([...readpointResponse.data.data]);
//     } catch (error) {
//       if (error.code === "ERR_NETWORK") {
//         navigate("/", { state: { from: location }, replace: true });
//       } else if (error.response.status === 401)
//         navigate("/", { state: { from: location }, replace: true });
//       else {
//         toast({
//           variant: "destructive",
//           title: "Error",
//           description: `${error?.response?.data?.message}`,
//         });
//       }
//     }

//     try {
//       const prodResponse = await getProductsbyKey({ clientKey: key });
//       console.log(prodResponse.data.data);
//       setProds([...prodResponse.data.data]);
//     } catch (error) {
//       console.log(error);
//       if (error.code === "ERR_NETWORK") {
//         navigate("/", { state: { from: location }, replace: true });
//       } else if (error.response.status === 401)
//         navigate("/", { state: { from: location }, replace: true });
//       else {
//         toast({
//           variant: "destructive",
//           title: "Error",
//           description: `${error?.response?.data?.message}`,
//         });
//       }
//     }
//   };
//   function handleToggleCharset(val) {
//     if (val === "rand") setToggleCharset(false)
//     else setToggleCharset(true)
//   }

//   return (
//     <div className="overflow-y-auto">
//         <Form {...form}>
//           <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
//             <FormField
//               control={form.control}
//               name="clientKey"
//               render={({ field }) => (
//                 <FormItem className="flex flex-col">
//                   <FormLabel>Clients</FormLabel>
//                   <Popover>
//                     <PopoverTrigger asChild>
//                       <FormControl>
//                         <Button
//                           variant="outline"
//                           role="combobox"
//                           className={cn(
//                             "w-[100%] justify-between",
//                             !field.value && "text-muted-foreground"
//                           )}>
//                           {field.value
//                             ? allClients?.find(
//                                 (client) => client?.key === field.value
//                               )?.name
//                             : "Select client"}
//                           <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
//                         </Button>
//                       </FormControl>
//                     </PopoverTrigger>
//                     <PopoverContent className=" w-[100%]">
//                       <Command>
//                         <CommandInput placeholder="Search location.." />
//                         <CommandEmpty>No client found.</CommandEmpty>
//                         <CommandGroup>
//                           {allClients.map((client) => (
//                             <CommandItem
//                               value={client?.key}
//                               key={client.key}
//                               onSelect={() => {
//                                 form.setValue("clientKey", client?.key);
//                                 handleChange(client?.key);
//                               }}>
//                               <Check
//                                 className={cn(
//                                   "mr-2 h-4 w-4",
//                                   client.key === field.value
//                                     ? "opacity-100"
//                                     : "opacity-0"
//                                 )}
//                               />
//                               {client.name}
//                             </CommandItem>
//                           ))}
//                         </CommandGroup>
//                       </Command>
//                     </PopoverContent>
//                   </Popover>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />

//             <FormField
//               control={form.control}
//               name="readpoint"
//               render={({ field }) => (
//                 <FormItem className="flex flex-col">
//                   <FormLabel>Locations</FormLabel>
//                   <Popover>
//                     <PopoverTrigger asChild>
//                       <FormControl>
//                         <Button
//                           variant="outline"
//                           role="combobox"
//                           className={cn(
//                             "w-[100%] justify-between",
//                             !field.value && "text-muted-foreground"
//                           )}>
//                           {field.value
//                             ? readpoint?.find((loc) => loc?.gln === field.value)
//                                 ?.address
//                             : "Select your location"}
//                           <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
//                         </Button>
//                       </FormControl>
//                     </PopoverTrigger>
//                     <PopoverContent className=" w-[100%] p-0">
//                       <Command>
//                         <CommandInput placeholder="Search location.." />
//                         <CommandEmpty>No locaton found.</CommandEmpty>
//                         <CommandGroup>
//                           {readpoint.map((loc) => (
//                             <CommandItem
//                               value={loc?.gln}
//                               key={loc?.gln}
//                               onSelect={() => {
//                                 form.setValue("readpoint", loc?.gln);
//                               }}>
//                               <Check
//                                 className={cn(
//                                   "mr-2 h-4 w-4",
//                                   loc?.gln === field.value
//                                     ? "opacity-100"
//                                     : "opacity-0"
//                                 )}
//                               />
//                               {loc?.address}
//                             </CommandItem>
//                           ))}
//                         </CommandGroup>
//                       </Command>
//                     </PopoverContent>
//                   </Popover>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />

//             <FormField
//               control={form.control}
//               name="gtin"
//               render={({ field }) => (
//                 <FormItem className="flex flex-col">
//                   <FormLabel>GTINs</FormLabel>
//                   <Popover>
//                     <PopoverTrigger asChild>
//                       <FormControl>
//                         <Button
//                           variant="outline"
//                           role="combobox"
//                           className={cn(
//                             "w-[100%] justify-between",
//                             !field.value && "text-muted-foreground"
//                           )}>
//                           {prodName ? prodName : "Select Gtin"}
//                           <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
//                         </Button>
//                       </FormControl>
//                     </PopoverTrigger>
//                     <PopoverContent className=" w-[100%] p-0">
//                       <Command>
//                         <CommandInput placeholder="Search products...." />
//                         <CommandEmpty>No GTIN found.</CommandEmpty>
//                         <CommandGroup>
//                           {prods.map((prod) => (
//                             <CommandItem
//                               value={`${prod.gtin},${prod.id},${prod.prod_name}`}
//                               key={prod?.id}
//                               onSelect={() => {
//                                 setProdName(prod.prod_name);
//                                 form.setValue(
//                                   "gtin",
//                                   `${prod.gtin},${prod.id},${prod.prod_name}`
//                                 );
//                               }}>
//                               <Check
//                                 className={cn(
//                                   "mr-2 h-4 w-4",
//                                   prod?.prod_name === prodName
//                                     ? // field.value.split(",").include(prod.prod_name)
//                                       "opacity-100"
//                                     : "opacity-0"
//                                 )}
//                               />
//                               {prod?.prod_name}
//                             </CommandItem>
//                           ))}
//                         </CommandGroup>
//                       </Command>
//                     </PopoverContent>
//                   </Popover>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />

//             <div className="flex gap-[10px]">
//               <FormField
//                 control={form.control}
//                 name="lotNumber"
//                 render={({ field }) => (
//                   <FormItem>
//                     <Label>LOT/BATCH NO.</Label>
//                     <FormControl>
//                       <Input
//                         className="flex-3"
//                         type="text"
//                         placeholder={"lot/batch number"}
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               <FormField
//                 control={form.control}
//                 name="qty"
//                 render={({ field }) => (
//                   <FormItem>
//                     <Label>Volume</Label>
//                     <FormControl>
//                       <Input
//                         className="flex-2"
//                         type="number"
//                         placeholder={"set volume"}
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />

//               <FormField
//                 control={form.control}
//                 name="tag"
//                 render={({ field }) => (
//                   <FormItem>
//                     <Label>Tag</Label>
//                     <FormControl>
//                       <Input
//                         className="flex-2"
//                         type="text"
//                         placeholder={"Set Tag"}
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//               />
//             </div>
//           <div className="flex gap-[30px]">
//             <FormField
//               control={form.control}
//               name="mode"
//               render={({ field }) => (
//                 <FormItem className="space-y-3">
//                   <fieldset className="border-2 border-gray-300 rounded-lg p-4">
//                     <legend className="text-sm font-medium leading-none">Serial Number Sequence Type</legend>
//                     <FormControl>
//                       <RadioGroup
//                         onValueChange={(val) => {
//                           field.onChange(val)
//                           handleToggleCharset(val)
//                         }}
//                         defaultValue={field.value}
//                         className="flex flex-col"
//                       >
//                         <FormItem className="flex items-center gap-3">
//                           <FormControl>
//                             <RadioGroupItem value="seq" />
//                           </FormControl>
//                           <FormLabel className="font-normal">
//                             Sequential Serial Number
//                           </FormLabel>
//                         </FormItem>
//                         <FormItem className="flex items-center gap-3">
//                           <FormControl>
//                             <RadioGroupItem value="rand" />
//                           </FormControl>
//                           <FormLabel className="font-normal">
//                             Random Serial Number
//                           </FormLabel>
//                         </FormItem>
//                       </RadioGroup>
//                     </FormControl>
//                   </fieldset>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />

//             <FormField
//               control={form.control}
//               name="charSet"
//               render={({ field }) => (
//                 <FormItem className="space-y-3">
//                   <fieldset className="border-2 border-gray-300 rounded-lg p-4">
//                     <legend className="text-sm font-medium leading-none">Serial Number Type</legend>
//                     <FormControl>
//                       <RadioGroup
//                         onValueChange={field.onChange}
//                         defaultValue={field.value}
//                         className="flex flex-col"
//                       >
//                         <FormItem className="flex items-center gap-3">
//                           <FormControl>
//                             <RadioGroupItem value="alpha-numeric" disabled={togglecharset} />
//                           </FormControl>
//                           <FormLabel className="font-normal">
//                             Alpha-numeric
//                           </FormLabel>
//                         </FormItem>
//                         <FormItem className="flex items-center gap-3">
//                           <FormControl>
//                             <RadioGroupItem value="numeric" />
//                           </FormControl>
//                           <FormLabel className="font-normal">
//                             Numeric
//                           </FormLabel>
//                         </FormItem>
//                       </RadioGroup>
//                     </FormControl>
//                   </fieldset>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />

//           </div>
//           <FormField
//             control={form.control}
//             name="length"
//             render={({ field }) => (
//               <FormItem className="flex flex-col">
//                 <FormLabel>Serial Number length</FormLabel>

//                 <Popover>
//                   <PopoverTrigger asChild>
//                     <FormControl>
//                       <Button
//                         variant="outline"
//                         role="combobox"
//                         className={cn(
//                           "w-[200px] justify-between",
//                           !field.value && "text-muted-foreground"
//                         )}
//                       >
//                         {field.value ?? "Select value"}
//                       </Button>
//                     </FormControl>
//                   </PopoverTrigger>

//                   <PopoverContent className="w-[200px] p-0">
//                     <Command>
//                       <CommandList>
//                         <CommandGroup>
//                           {["8", "10", "12", "14"].map((value) => (
//                             <CommandItem
//                               value={value}
//                               key={value}
//                               onSelect={() => form.setValue("length", value)}
//                             >
//                               {value}
//                               <Check
//                                 className={cn(
//                                   "ml-auto",
//                                   field.value === value ? "opacity-100" : "opacity-0"
//                                 )}
//                               />
//                             </CommandItem>
//                           ))}
//                         </CommandGroup>
//                       </CommandList>
//                     </Command>
//                   </PopoverContent>
//                 </Popover>
//                 <FormMessage />
//               </FormItem>
//             )}
//           />

//           <div className="flex gap-[20px]">
//             <FormField
//                 control={form.control}
//                 name="mfgDate"
//                 render={({ field }) => (
//                   <FormItem className="flex flex-col">
//                     <FormLabel>MFG Date</FormLabel>
//                     <FormControl>
//                       <Input
//                         className="flex-6"
//                         type="date"
//                         autoComplete="off"
//                         {...field}
//                       />
//                     </FormControl>
//                   <FormMessage />
//                 </FormItem>
//               )}
//             />
//             <FormField
//               control={form.control}
//               name="expiryDate"
//               render={({ field }) => (
//                 <FormItem className="flex flex-col">
//                   <FormLabel>Expiry Date</FormLabel>
//                   <FormControl>
//                     <Input
//                       className="flex-6"
//                       type="date"
//                       autoComplete="off"
//                       {...field}
//                     />
//                   </FormControl>
//                     <FormMessage />
//                   </FormItem>
//                 )}
//             />

//             <div className="p-[20px]">
//               <Button type="submit" disabled={loading} >
//               {loading ? (
//                   <span className="mx-[10px]">
//                   <ClipLoader color="primary" size={20} />
//                 </span>
//               ) : (
//                 <span>Submit</span>
//               )}
//             </Button>
//             </div>

//           </div>
//           </form>
//       </Form>
//     </div>
//   );
// }

// export default SgtinModal;




import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Label } from "./ui/label";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "./ui/form";
import { Input } from "./ui/input";
import { Button } from "./ui/button";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { z } from "zod";
import { useToast } from "./ui/use-toast";
import { ClipLoader } from "react-spinners";
import { cn } from "../lib/utils";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Check, ChevronsUpDown } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "./ui/radio-group";

// Hooks
import { 
  useGetAllClients, 
  useCheckClientLocations, 
  useGetClientProducts
} from "../migration-api/api-hooks/clients";
import { useGenerateSGTIN } from "../migration-api/api-hooks/serialization";

function SgtinModal({ latitude, longitude }) {
  const { toast } = useToast();
  const [togglecharset, setToggleCharset] = useState(true);
  const [readpoint, setReadpoint] = useState([]);
  const [prods, setProds] = useState([]);
  const [prodName, setProdName] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");

  // Form schema
  const formSchema = z.object({
    clientId: z.string({
      message: "This field is required",
    }),
    mode: z.string({
      message: "This field is required",
    }),
    length: z.string({
      message: "This field is required",
    }),
    charSet: z.string({
      message: "This field is required",
    }),
    gtin: z.string({
      message: "This field is required",
    }),
    readpoint: z.string({
      message: "This field is required",
    }),
    expiryDate: z.string({
      message: "This field is required",
    }),
    mfgDate: z.string({
      message: "This field is required",
    }),
    qty: z.string({
      message: "This field is required",
    }),
    tag: z.string({
      message: "This field is required",
    }),
    lotNumber: z.string({
      message: "This field is required",
    }),
  });

  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      clientId: "",
      gtin: "",
      readpoint: "",
      qty: "",
      tag: "",
      lotNumber: "",
      mode: "",
      charSet: "",
      length: "",
      expiryDate: "",
      mfgDate: "",
    },
  });

  // Fetch all clients
  const { data: clientsData, isLoading: isLoadingClients } = useGetAllClients();
  const allClients = clientsData?.data || [];

  // Fetch client products (GET query - automatically fetches when selectedClientId changes)
  const { data: productsData, isLoading: isLoadingProducts } = useGetClientProducts(
    selectedClientId,
    {
      enabled: !!selectedClientId,
    }
  );

  // Update prods when productsData changes
  useEffect(() => {
    if (productsData) {
      console.log("Products loaded:", productsData);
      setProds(productsData?.data || []);
    }
  }, [productsData]);

  // Check/fetch client locations (assuming this is a mutation/POST method)
  const { mutate: checkClientLocations, isLoading: isLoadingLocations } = useCheckClientLocations({
    onSuccess: (data) => {
      console.log("Locations loaded:", data);
      setReadpoint(data?.data?.locations || []);
    },
    onError: (error) => {
      console.error("Error loading locations:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to load locations",
      });
      setReadpoint([]);
    },
  });

  console.log("Location payload: ", { client_email: selectedEmail });
  console.log("Check Locations - readpoint:", readpoint);
  // Generate SGTIN mutation
  const { mutate: generateSGTIN, isLoading: isGenerating } = useGenerateSGTIN({
    onSuccess: (data) => {
      toast({
        variant: "success",
        title: "Success",
        description: data?.message || "SGTIN labels generated successfully",
      });
      // Reset form after success
      form.reset();
      setProdName("");
      setSelectedClientId("");
      setSelectedEmail("");
      setReadpoint([]);
      setProds([]);
    },
    onError: (error) => {
      toast({
        variant: "destructive",
        title: "Error",
        description: error?.response?.data?.message || "Failed to generate SGTIN labels",
      });
    },
  });

  function onSubmit(data) {
    // Validate charset and mode combination
    if (data.charSet === "alpha-numeric" && data.mode === "seq") {
      toast({
        variant: "destructive",
        title: "Error",
        description: "Invalid selection: Alpha-numeric cannot be used with Sequential mode",
      });
      return;
    }

    // Extract prodId from gtin field (format: "gtin,prodId,prodName")
    const gtinParts = data.gtin.split(',');
    const prodId = gtinParts[1];

    // Prepare payload according to API structure
    const payload = {
      clientId: parseInt(data.clientId), // Convert to number
      mode: data.mode,
      charSet: data.charSet,
      qty: parseInt(data.qty),
      length: parseInt(data.length) || 8,
      prodId: parseInt(prodId),
      tag: data.tag,
      expiryDate: new Date(data.expiryDate).toISOString().replace("Z", ""),
      lotNumber: data.lotNumber,
      mfgDate: new Date(data.mfgDate).toISOString().replace("Z", ""),
      eventObjectParameter: {
        eventTime: new Date().toISOString().replace("Z", ""),
        recordTime: new Date().toISOString().replace("Z", ""),
        timeZone: "+01:00",
        latitude: latitude,
        longitude: longitude,
        readPoint: data.readpoint,
        disposition: "urn:epcglobal:cbv:disp:active",
      },
      isNafdac: false,
    };

    console.log("Submitting SGTIN payload:", payload);
    generateSGTIN(payload);
  }

  const handleClientChange = (clientId, clientEmail) => {
    console.log("Client selected, ID:", clientId);
    setSelectedClientId(clientId);
    setSelectedEmail(clientEmail);
    form.setValue("clientId", clientId);
    
    // Reset dependent fields
    form.setValue("gtin", "");
    form.setValue("readpoint", "");
    setProdName("");
    setReadpoint([]);
    setProds([]);

    // Fetch locations for this client (POST method with payload)
    checkClientLocations({ client_email: clientEmail });
    
    // Products will be fetched automatically by the query hook
    // since selectedClientId changed
  };

  function handleToggleCharset(val) {
    if (val === "rand") {
      setToggleCharset(false);
    } else {
      setToggleCharset(true);
    }
  }

  return (
    <div className="overflow-y-auto max-h-[80vh]">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-8">
          {/* Client Selection */}
          <FormField
            control={form.control}
            name="clientId"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Clients</FormLabel>
                <Popover>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        variant="outline"
                        role="combobox"
                        disabled={isLoadingClients}
                        className={cn(
                          "w-[100%] justify-between",
                          !field.value && "text-muted-foreground"
                        )}
                      >
                        {isLoadingClients
                          ? "Loading clients..."
                          : field.value
                          ? allClients?.find((client) => client?.id === parseInt(field.value))
                              ?.clientName
                          : "Select client"}
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-[100%] p-0">
                    <Command>
                      <CommandInput placeholder="Search client..." />
                      <CommandEmpty>No client found.</CommandEmpty>
                      <CommandGroup>
                        <CommandList>
                          {allClients.map((client) => (
                            <CommandItem
                              value={client?.clientName}
                              key={client.id}
                              onSelect={() => handleClientChange(client?.id.toString(), client?.email)}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  client.id === parseInt(field.value)
                                    ? "opacity-100"
                                    : "opacity-0"
                                )}
                              />
                              {client.clientName}
                            </CommandItem>
                          ))}
                        </CommandList>
                      </CommandGroup>
                    </Command>
                  </PopoverContent>
                </Popover>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Location Selection */}
          <FormField
            control={form.control}
            name="readpoint"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Locations</FormLabel>
                <Popover>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        variant="outline"
                        role="combobox"
                        disabled={!selectedClientId || isLoadingLocations}
                        className={cn(
                          "w-[100%] justify-between",
                          !field.value && "text-muted-foreground"
                        )}
                      >
                        {!selectedClientId
                          ? "Select client first..."
                          : isLoadingLocations
                          ? "Loading locations..."
                          : field.value
                          ? readpoint?.find((loc) => loc?.gln === field.value)?.address
                          : "Select your location"}
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-[100%] p-0">
                    <Command>
                      <CommandInput placeholder="Search location..." />
                      <CommandEmpty>No location found.</CommandEmpty>
                      <CommandGroup>
                        <CommandList>
                          {readpoint.map((loc) => (
                            <CommandItem
                              value={loc?.gln}
                              key={loc?.gln}
                              onSelect={() => {
                                form.setValue("readpoint", loc?.gln);
                              }}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  loc?.gln === field.value ? "opacity-100" : "opacity-0"
                                )}
                              />
                              {loc?.address}
                            </CommandItem>
                          ))}
                        </CommandList>
                      </CommandGroup>
                    </Command>
                  </PopoverContent>
                </Popover>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* GTIN/Product Selection */}
          <FormField
            control={form.control}
            name="gtin"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>GTINs</FormLabel>
                <Popover>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        variant="outline"
                        role="combobox"
                        disabled={!selectedClientId || isLoadingProducts}
                        className={cn(
                          "w-[100%] justify-between",
                          !field.value && "text-muted-foreground"
                        )}
                      >
                        {!selectedClientId
                          ? "Select client first..."
                          : isLoadingProducts
                          ? "Loading products..."
                          : prodName
                          ? prodName
                          : "Select GTIN"}
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-[100%] p-0">
                    <Command>
                      <CommandInput placeholder="Search products..." />
                      <CommandEmpty>No GTIN found.</CommandEmpty>
                      <CommandGroup>
                        <CommandList>
                          {prods.map((prod) => (
                            <CommandItem
                              value={`${prod.gtin},${prod.id},${prod.prodName}`}
                              key={prod?.id}
                              onSelect={() => {
                                setProdName(prod.prodName);
                                form.setValue(
                                  "gtin",
                                  `${prod.gtin},${prod.id},${prod.prodName}`
                                );
                              }}
                            >
                              <Check
                                className={cn(
                                  "mr-2 h-4 w-4",
                                  prod?.prodName === prodName ? "opacity-100" : "opacity-0"
                                )}
                              />
                              {prod?.prodName}
                            </CommandItem>
                          ))}
                        </CommandList>
                      </CommandGroup>
                    </Command>
                  </PopoverContent>
                </Popover>
                <FormMessage />
              </FormItem>
            )}
          />

          {/* Lot Number, Volume, Tag */}
          <div className="flex gap-[10px]">
            <FormField
              control={form.control}
              name="lotNumber"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <Label>LOT/BATCH NO.</Label>
                  <FormControl>
                    <Input
                      type="text"
                      placeholder="lot/batch number"
                      autoComplete="off"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="qty"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <Label>Volume</Label>
                  <FormControl>
                    <Input
                      type="number"
                      placeholder="set volume"
                      autoComplete="off"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="tag"
              render={({ field }) => (
                <FormItem className="flex-1">
                  <Label>Tag</Label>
                  <FormControl>
                    <Input type="text" placeholder="Set Tag" autoComplete="off" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          {/* Serial Number Mode and Type */}
          <div className="flex gap-[30px]">
            <FormField
              control={form.control}
              name="mode"
              render={({ field }) => (
                <FormItem className="space-y-3 flex-1">
                  <fieldset className="border-2 border-gray-300 rounded-lg p-4">
                    <legend className="text-sm font-medium leading-none">
                      Serial Number Sequence Type
                    </legend>
                    <FormControl>
                      <RadioGroup
                        onValueChange={(val) => {
                          field.onChange(val);
                          handleToggleCharset(val);
                        }}
                        defaultValue={field.value}
                        className="flex flex-col"
                      >
                        <FormItem className="flex items-center gap-3">
                          <FormControl>
                            <RadioGroupItem value="seq" />
                          </FormControl>
                          <FormLabel className="font-normal">Sequential Serial Number</FormLabel>
                        </FormItem>
                        <FormItem className="flex items-center gap-3">
                          <FormControl>
                            <RadioGroupItem value="rand" />
                          </FormControl>
                          <FormLabel className="font-normal">Random Serial Number</FormLabel>
                        </FormItem>
                      </RadioGroup>
                    </FormControl>
                  </fieldset>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="charSet"
              render={({ field }) => (
                <FormItem className="space-y-3 flex-1">
                  <fieldset className="border-2 border-gray-300 rounded-lg p-4">
                    <legend className="text-sm font-medium leading-none">
                      Serial Number Type
                    </legend>
                    <FormControl>
                      <RadioGroup
                        onValueChange={field.onChange}
                        defaultValue={field.value}
                        className="flex flex-col"
                      >
                        <FormItem className="flex items-center gap-3">
                          <FormControl>
                            <RadioGroupItem value="alpha-numeric" disabled={togglecharset} />
                          </FormControl>
                          <FormLabel className="font-normal">Alpha-numeric</FormLabel>
                        </FormItem>
                        <FormItem className="flex items-center gap-3">
                          <FormControl>
                            <RadioGroupItem value="numeric" />
                          </FormControl>
                          <FormLabel className="font-normal">Numeric</FormLabel>
                        </FormItem>
                      </RadioGroup>
                    </FormControl>
                  </fieldset>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>

          {/* Serial Number Length */}
          {/* <FormField
            control={form.control}
            name="length"
            render={({ field }) => (
              <FormItem className="flex flex-col">
                <FormLabel>Serial Number Length</FormLabel>
                <Popover>
                  <PopoverTrigger asChild>
                    <FormControl>
                      <Button
                        variant="outline"
                        role="combobox"
                        className={cn(
                          "w-[200px] justify-between",
                          !field.value && "text-muted-foreground"
                        )}
                      >
                        {field.value ?? "Select value"}
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </Button>
                    </FormControl>
                  </PopoverTrigger>
                  <PopoverContent className="w-[200px] p-0">
                    <Command>
                      <CommandList>
                        <CommandGroup>
                          {["8", "10", "12", "14"].map((value) => (
                            <CommandItem
                              value={value}
                              key={value}
                              onSelect={() => form.setValue("length", value)}
                            >
                              {value}
                              <Check
                                className={cn(
                                  "ml-auto",
                                  field.value === value ? "opacity-100" : "opacity-0"
                                )}
                              />
                            </CommandItem>
                          ))}
                        </CommandGroup>
                      </CommandList>
                    </Command>
                  </PopoverContent>
                </Popover>
                <FormMessage />
              </FormItem>
            )}
          /> */}

          {/* Dates and Submit */}
          <div className="flex gap-[20px] items-end">
            <FormField
              control={form.control}
              name="mfgDate"
              render={({ field }) => (
                <FormItem className="flex flex-col flex-1">
                  <FormLabel>MFG Date</FormLabel>
                  <FormControl>
                    <Input type="date" autoComplete="off" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="expiryDate"
              render={({ field }) => (
                <FormItem className="flex flex-col flex-1">
                  <FormLabel>Expiry Date</FormLabel>
                  <FormControl>
                    <Input type="date" autoComplete="off" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <Button type="submit" disabled={isGenerating} className="px-8">
              {isGenerating ? (
                <span className="flex items-center gap-2">
                  <ClipLoader color="white" size={20} />
                  <span>Generating...</span>
                </span>
              ) : (
                <span>Submit</span>
              )}
            </Button>
          </div>
        </form>
      </Form>
    </div>
  );
}

export default SgtinModal;